import {
    useSubCategoriesTikTok,
    useUserIndustriesTikTok,
} from 'utils/hooks/useUserIndustries';
import { formatGrowth, formatVolume } from 'utils/helpers';
import { DATA_SOURCES } from '@/config/constants';
import { createSourceBreadCrumbs } from './createSourceBreadCrumbs';

const tikTokMetrics = [
    {
        key: 'non_cum_avg_weekly_views',
        label: 'views',
        formatter: formatVolume,
    },
    { key: 'non_cum_YoY_rolling', label: 'YoY', formatter: formatGrowth },
];

const tikTokBrandMetrics = [
    { key: 'non_cum_brand_views', label: 'views', formatter: formatVolume },
    {
        key: 'non_cum_brand_views_YoY_rolling',
        label: 'YoY',
        formatter: formatGrowth,
    },
];

const {
    BreadCrumbs: TikTokBreadCrumbs,
    IndustriesOnlyBreadCrumbs: TikTokIndustriesOnlyBreadCrumbs,
} = createSourceBreadCrumbs({
    dataSource: DATA_SOURCES.TIKTOK,
    useSubcategories: useSubCategoriesTikTok,
    useIndustries: useUserIndustriesTikTok,
    metrics: tikTokMetrics,
    industriesOnlyMetrics: tikTokBrandMetrics,
});

export { TikTokIndustriesOnlyBreadCrumbs };

export default TikTokBreadCrumbs;
